<greco-simple-dialog [data]="dialogData">
  <greco-active-promotions [promotions]="data.promotions"></greco-active-promotions>
</greco-simple-dialog>
